// extracted by mini-css-extract-plugin
export default {"normal-height":"qP2pi","author-info":"nkN9U"};